import styled from '@emotion/styled';
import { Icon, Text, tokens } from '@hotjar/hotsauce';

const StyledError = styled(Text)`
  display: block;
  margin-top: ${tokens.spacer.x1};
`;

const StyledSuccess = styled(Text)`
  display: block;
  margin-top: ${tokens.spacer.x1};
`;

const StyledIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;

const ProviderIcon = styled.img`
  margin-right: ${tokens.spacer.x0};
`;

const Link = styled.a`
  margin-right: ${tokens.spacer.x3};
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 12px;
  color: ${tokens.color.text_light};

  &:hover {
    color: ${tokens.color.text_default};
    text-decoration: none;
  }
`;

const ProviderLinks = styled.div`
  margin-top: ${tokens.spacer.x4};
  margin-bottom: ${tokens.spacer.x4};
  display: flex;
`;

export const EmailVerificationComponentStyles = {
  StyledError,
  StyledSuccess,
  StyledIcon,
  ProviderIcon,
  Link,
  ProviderLinks,
};
